import {Model, formatter} from 'MWComponents';
import {Validator} from '../validator/validator';

const PHONE_NUMBER = 'phone',
    formatsArr = {
        [PHONE_NUMBER]: '_phoneFormat'
    };

export default class extends Model {
    static fields;

    isValid = false;

    constructor(data) {
        super();
        this.initData(data);
    }

    initData(data) {
        this.fields = {
            name: {
                value: '',
                firstInput: true,
                isValid: true,
                errors: [],
                validates: [Validator.isNotEmpty, Validator.isMoreTwo]
            },
            phone: {
                value: '',
                firstInput: true,
                isValid: true,
                errors: [],
                validates: [Validator.isNotEmpty, Validator.phone]
            },
            email: {
                value: '',
                firstInput: true,
                isValid: true,
                errors: [],
                validates: [Validator.isNotEmpty, Validator.email]
            },
            product: {
                value: '',
                firstInput: true,
                isValid: true,
                errors: [],
                validates: [Validator.isNotEmpty, Validator.isMoreTwo]
            },
            company: {
                value: '',
                firstInput: true,
                isValid: true,
                errors: [],
                validates: [Validator.isNotEmpty, Validator.isMoreTwo]
            },
            info: {
                value: '',
                firstInput: true,
                isValid: true,
                errors: [],
                validates: [Validator.isNotEmpty, Validator.isMoreTwo]
            }
        };
    }

    getField(fieldName) {
        return this.fields[fieldName];
    }

    run(data) {
        const name = data.name,
            value = formatsArr[name] ? this[formatsArr[name]](data.value) : data.value;

        this.fields[name].value = value;

        this.isValid = this.validate();
    }

    changeFirst(name) {
        this.fields[name].firstInput = false;
    }

    validate() {
        let result = true;
        // eslint-disable-next-line guard-for-in
        for (const item in this.fields) {
            Validator.validate(this.fields[item]);
            if (!this.fields[item].isValid) {
                result = false;
            }
        }

        return result;
    }

    _phoneFormat = value => {
        return formatter(value, '+{{dd}} ({{ddd}}) {{ddd}} {{dd}} {{dd}}');
    };
}
